import React from "react";
import CloseIcon from "../../../../assets/icons/close.svg";

const ProgressModal = (props) => {
    return props.open && (
        <div className="flex column justifyCenter alignCenter" style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, background: "rgba(0,0,0,0.7)" }}>
            <div style={{ background: "#ffffff", height: 320, maxHeight: 320, width: 576, borderRadius: 8 }}>
                <div className="h-100 w-100" style={{ overflow: "auto", position: "relative" }}>
                    <div className="flex justifyBetween alignCenter w-100"
                        style={{
                            borderBottom: "1px solid #E0E0E0",
                            padding: "20px 16px 8px",
                            height: 72
                        }}
                    >
                        <h2 className="flex alignCenter w-100" style={{ color: "#009688" }}>
                            کام جاری ہے کارڈ
                        </h2>

                        <img src={CloseIcon} alt="close_icon" height={32} width={32} onClick={props.onClose} style={{ cursor: "pointer" }} />
                    </div>

                    <div style={{ margin: "32px 24px 16px" }}>
                        <h4 style={{ fontSize: 32, lineHeight: 2 }}>یہ فیچر ابھی تیار نہیں ہوا ہے اور ہم ابھی تک اس پر کام کر رہے ہیں۔ براہ کرم ہمارے ساتھ صبر کریں۔</h4>
                    </div>

                    {/* button */}
                    <div className="flex justifyEnd alignCenter w-100" style={{ height: 64, paddingLeft: 16 }}>
                        <div className="flex justifyEnd alignCenter delete_button"
                            style={{ padding: "12px 40px 0px", margin: 0 }}
                            onClick={props.onClose}
                        >
                            <h3>{`منسوخ کریں`}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProgressModal;